const API_BASE_URL = process.env.GATSBY_API_BASE_URL || 'http://localhost:3000/api/v1';

// Helper to dynamically get full image/file URLs from backend
export const getMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  // Extract server base URL by removing '/api/v1' from the end of API_BASE_URL
  const serverBase = API_BASE_URL.replace(/\/api\/v1\/?$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${serverBase}${cleanPath}`;
};

// Helper to convert simple Markdown bullet lists to HTML
export const convertMarkdownToHtml = (md) => {
  if (!md) return '';
  const lines = md.split('\n');
  let inList = false;
  const htmlLines = [];

  lines.forEach(line => {
    const trimmed = line.trim();
    if (trimmed.startsWith('- ') || trimmed.startsWith('* ')) {
      const content = trimmed.substring(2);
      if (!inList) {
        inList = true;
        htmlLines.push('<ul>');
      }
      htmlLines.push(`<li>${content}</li>`);
    } else if (trimmed === '') {
      if (inList) {
        inList = false;
        htmlLines.push('</ul>');
      }
    } else {
      if (inList) {
        inList = false;
        htmlLines.push('</ul>');
      }
      htmlLines.push(`<p>${trimmed}</p>`);
    }
  });

  if (inList) {
    htmlLines.push('</ul>');
  }

  return htmlLines.join('\n');
};

// API Fetch Helper
export const fetchFromApi = async (endpoint) => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3-second timeout

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const json = await response.json();
    if (json.success && json.data) {
      return json.data;
    }
    return null;
  } catch (error) {
    console.warn(`[Gatsby API Integration] Failed to fetch from ${endpoint}:`, error.message);
    return null;
  }
};
